<template>
  <vs-popup id="popupRiskFrequency" title="<표 1> 위험발생 가능성 (빈도)" :active.sync="popupActiveSync">
    <div class="p-4">
      <table>
        <thead>
          <tr>
            <th>발생빈도</th>
            <th>사고발생</th>
            <th>작업빈도(月)</th>
            <th>안전장치(年)</th>
            <th>기준위반(年)</th>
            <th>근골격계요인(年)</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>5(HH)</td>
          <td>안전사고, 아차사고가 최근 1년 이내 3회 이상</td>
          <td>위험구역 1m 이내 근접 30회 이상</td>
          <td>안전장치 고장 4회 이상</td>
          <td>기준위반 4회 이상</td>
          <td>요인대상 작업 50% 이상</td>
        </tr>
        <tr>
          <td>4(HM)</td>
          <td>안전사고, 아차사고가 최근 1년 이내 2회 이상</td>
          <td>위험구역 1m 이내 근접 21~30회 이상</td>
          <td>안전장치 고장 3회 이상</td>
          <td>기준위반 3회</td>
          <td>요인대상 작업 50% 미만</td>
        </tr>
        <tr>
          <td>3(MM)</td>
          <td>안전사고, 아차사고가 최근 1년 이내 1회 이상</td>
          <td>위험구역 1m 이내 근접 11~20회 이상</td>
          <td>안전장치 고장 2회 이상</td>
          <td>기준위반 2회</td>
          <td>요인대상 작업 30% 미만</td>
        </tr>
        <tr>
          <td>2(ML)</td>
          <td>안전사고, 아차사고가 최근 1년 이내 없음</td>
          <td>위험구역 1m 이내 근접 1~10회 이상</td>
          <td>안전장치 고장 1회 이상</td>
          <td>기준위반 1회</td>
          <td>요인대상 작업 20% 미만</td>
        </tr>
        <tr>
          <td>1(LL)</td>
          <td>안전사고, 아차사고가 최근 3년 이내 없음</td>
          <td>위험구역 1m 이내 근접 1회 이상</td>
          <td>안전장치 고장 0회 이상</td>
          <td>기준위반 0회</td>
          <td>요인대상 작업 10% 미만</td>
        </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskDksteelFrequency',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px;
    text-align: center;
    font-size: 14px;
    color: #3c3c3c;
    line-height: 20px;
  }

  thead {
    th {
      font-weight: 700;
      background: #f9f9f9;
    }
  }
  tbody {
    td {
      font-weight: 400;
    }
  }
}
</style>
<style>

#popupRiskFrequency > .vs-popup {
  width: 1167px !important;
}

#popupRiskFrequency > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskFrequency > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
